<template>
  <div>
    <h1>Server-Side Facts</h1>
    <AgGridVue
      style="width: 100%; height: 640px;"
      class="ag-theme-balham"
      :rowData="dataset"
      :gridOptions="gridOptions"
      :floatingFilter="true"
    ></AgGridVue>
  </div>
</template>

<script>
import axios from "axios";
import { AgGridVue } from "ag-grid-vue";
import CopyButton from "@/grid-components/copy-button.vue";
import LinkComponent from "@/grid-components/link.vue";
import TagsComponent from "@/grid-components/tags";

export default {
  components: {
    AgGridVue,
    CopyButton,
    LinkComponent,
  },
  data() {
    return {
      dataset: [],
      gridOptions: {
        rowModelType: "serverSide",

        columnDefs: [
          {
            suppressMenu: true,
            resizable: false,
            headerName: "IDU",
            field: "idu",
            width: 50,
            enableRowGroup: true,
            cellRenderer: params => {
              if (params.node.data) {
                return params.node.data.idu
                  ? '<i class="fa fa-check-circle"></i>'
                  : "";
              }
            },
          },
          {
            headerName: "Groups",
            field: "groups",
            cellRendererFramework: TagsComponent,
            cellRendererParams: {
              items: data => data.groups || [],
            },
          },
          { headerName: "Country", field: "country", enableRowGroup: true },
          {
            headerName: "Year",
            field: "year",
            width: 70,
            filter: "number",
            enableRowGroup: true,
          },
          {
            headerName: "cause",
            field: "displacement_type",
            filter: "agSetColumnFilter",
            filterParams: { values: ["Conflict", "Disaster", "Development"] },
            width: 90,
            enableRowGroup: true,
          },
          { headerName: "Type", field: "type", enableRowGroup: true },
          {
            headerName: "Stock Date",
            field: "stock_date",
            width: 120,
          },
          {
            headerName: "Start Date",
            field: "start_date",
            width: 120,
          },
          {
            headerName: "End Date",
            field: "end_date",
            width: 120,
          },
          { headerName: "Event Name", field: "event_name" },
          {
            headerName: "Name",
            field: "name",
            width: 250,
            cellRendererFramework: LinkComponent,
            cellRendererParams: {
              link: data => `/facts/${data.id}`,
              name: data => data.name,
            },
          },
          {
            headerName: "Class",
            field: "class",
            width: 70,
            enableRowGroup: true,
          },
          {
            headerName: "Role (Event)",
            field: "event_role",
            enableRowGroup: true,
          },
          {
            headerName: "Role (Master)",
            field: "parent_role",
            enableRowGroup: true,
          },
          {
            headerName: "Hazard Subtype",
            field: "hazard_subtype",
            enableRowGroup: true,
          },
          {
            headerName: "Public Figure Analysis",
            field: "public_figure_analysis",
            width: 120,
            hide: true,
          },
          { headerName: "GSN", field: "gsn", width: 140, hide: true },
          { headerName: "Status", field: "status", enableRowGroup: true },
          {
            headerName: "Figure",
            field: "figure",
            valueFormatter: ({ value }) => {
              if (!!value) {
                return value
                  .toString()
                  .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
              } else {
                return "";
              }
            },
            width: 90,
            hide: true,
          },
          { headerName: "Qualifier", field: "qualifier", hide: true },
          {
            headerName: "Sources",
            field: "sources",
            cellRendererFramework: TagsComponent,
            cellRendererParams: {
              items: data => data.sources || [],
            },
            hide: true,
          },
          { headerName: "Created at", field: "created_at", hide: true },
          {
            headerName: "Created by",
            field: "created_by",
            enableRowGroup: true,
            hide: true,
          },
        ],

        defaultColDef: {
          resizable: true,
          sortable: true,
          filterable: true,
        },

        // debug: true,
        // cacheBlockSize: 20,
        // maxBlocksInCache: 3,
        // purgeClosedRowNodes: true,
        // maxConcurrentDatasourceRequests: 2,
        // blockLoadDebounceMillis: 1000
      },
    };
  },
  mounted() {
    this.gridOptions.api.setServerSideDatasource({
      async getRows(params) {
        console.log(JSON.stringify(params.request, null, 1));

        const {
          startRow,
          endRow,
          rowGroupCols,
          valueCols,
          pivotCols,
          pivotMode,
          groupKeys,
          filterModel,
          sortModel,
        } = params.request;

        let conditions = {};
        for (const column in filterModel) {
          if (filterModel.hasOwnProperty(column)) {
            const { filterType, type, filter, filterTo } = filterModel[column];
            console.log({ filterType, type, filter, filterTo });
            if (!!type) {
              const types = {
                equals: "eq",
                notEqual: "neq",
                lessThan: "lt",
                lessThanOrEqual: "lte",
                greaterThan: "gt",
                greaterThanOrEqual: "gte",
                inRange: "range",
              };
              conditions[column] = `${types[type]}.${filter}`;
            }
          }
        }

        // "filterModel": {
        //  "year": {
        //   "filterType": "number",
        //   "type": "equals",
        //   "filter": 2016,
        //   "filterTo": null
        //  }
        // },

        try {
          let response = await axios.get("/psql/facts_view", {
            params: {
              ...conditions,
              limit: endRow - startRow,
              offset: startRow,
              order:
                sortModel.length > 0
                  ? `${sortModel[0].colId}.${sortModel[0].sort}`
                  : undefined,
            },
          });
          const dataset = { rows: response.data, lastRow: -1 };
          // console.log({ dataset });
          params.successCallback(dataset.rows, dataset.lastRow);
        } catch (error) {
          console.error(error);
          params.failCallback();
        }
      },
    });
  },
};

// const defaultColumnDefs = ;
</script>
